import { useTranslation } from 'react-i18next';
import type { Article } from '@erp/data-access/interfaces';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from '@erp/ui';
import { Button } from '@erp/ui';
import { ArticleForm } from './ArticleForm';

interface ArticleFormDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  article?: Article | null;
}

export function ArticleFormDialog({ open, onOpenChange, article }: ArticleFormDialogProps) {
  const { t } = useTranslation();
  const isEdit = !!article;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {isEdit ? t('articles.editArticle') : t('articles.newArticle')}
          </DialogTitle>
        </DialogHeader>

        <ArticleForm
          key={article ? `${article.id}:${article.categoryId ?? ''}:${article.subFamily ?? ''}:${article.family ?? ''}:${article.brand ?? ''}` : 'new'}
          article={article}
          onSaved={() => onOpenChange(false)}
          renderFooter={({ submitButton }) => (
            <DialogFooter>
              <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
                {t('common.cancel')}
              </Button>
              {submitButton}
            </DialogFooter>
          )}
        />
      </DialogContent>
    </Dialog>
  );
}
